<template>
  <el-dialog title="用户存取款" :visible.sync="visible" width="400px">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="金额">
        <el-input-number v-model="form.amount"  :precision="2" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { depositUser } from '@/api/carft'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        type: 'deposit',
        amount: 0
      },
      dialogVisible: this.visible
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      depositUser(this.user.id, this.form.amount).then(() => {
        this.$emit('refresh')
        this.closeDialog()
      })
    }
  }
}
</script>
